import React, { useEffect } from 'react';
import { useLocation } from 'react-router';
import Routes from 'routes';

const FsScrollToTop: React.FC = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    const specialCase = new RegExp(Routes.REPORT).test(pathname);
    if (!specialCase) {
      window.scrollTo(0, 0);
    }
  }, [pathname]);

  return null;
};

export default FsScrollToTop;
